module.exports = __webpack_public_path__ + "media/images/icon-webmil-2af0cd51664168aee8f75633d514a29f.svg";